import { FLAG_STATUSES } from './../../constants';

const mapFlag = FLAG_STATUSES;

export default function mapFromRaceData(raceData) {
    return {
        flagState: mapFlag[raceData.C],
        timeLeft: raceData.T
    };
}